import { render, staticRenderFns } from "./EditSocialModal.vue?vue&type=template&id=78954ae4&scoped=true&%23default=%7B%7D&"
import script from "./EditSocialModal.vue?vue&type=script&lang=js&"
export * from "./EditSocialModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./EditSocialModal.vue?vue&type=style&index=1&id=78954ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78954ae4",
  null
  
)

export default component.exports